import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Billet de banque — déclarations financières duotone.
 * Symbole € au centre (€, jamais $, on est en France).
 */
export const BanknoteIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Fond billet menthe */}
      <rect x="2.5" y="6.5" width="19" height="11" rx="1.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      {/* Contour billet */}
      <rect x="2.5" y="6.5" width="19" height="11" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Pastille € au centre */}
      <circle cx="12" cy="12" r="3" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path
        d="M13.5 10.7a2 2 0 0 0-3 1.3 2 2 0 0 0 3 1.3M10.5 11.5h2.5M10.5 12.5h2"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.1" strokeLinecap="round"
      />
      {/* Petits accents aux coins */}
      <circle cx="5.5" cy="12" r="0.9" fill="var(--equiply-icon-fg)" />
      <circle cx="18.5" cy="12" r="0.9" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
BanknoteIcon.displayName = "BanknoteIcon";
